export const url = {
  decodeHash: (hash) => {
    return hash ? decodeURI(hash.substring(1)) : null;
  },
};
